import * as $ from 'jquery';
import { disposableSubscription, serialDisposable, disposable } from 'common/barrels/core';

import { LooklessControl } from 'runtime/controls/looklesscontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';
import { DialogRequested } from 'runtime/events/dialogrequested';
import { ConfirmUploadDialog } from 'runtime/dialogs/confirmuploaddialog';
import { ActivityExecutionRequested } from 'runtime/events/activityexecutionrequested';
import { ActivityUpdate } from 'runtime/data/activityupdate';
import { ActivityFileParameter } from 'runtime/data/activityfileparameter';

export class UploadControl extends LooklessControl {
    private activityName: string;
    private inputDisposable = serialDisposable(null);

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.activityName = this.config['content.ActivityName'];

        this.$element.addClass('invisible-but-not-hidden').show();
    }

    upload(parameter, done) {
        var confirmationRequired = ((<any>window).FormData === undefined);

        var afterUpload = x => {
            this.inputDisposable.set(null);

            if ((<ActivityUpdate>x).results.some(y => y.name === 'FileContentError' && y.value === true))
                this.triggerEvent('FileContentError');

            done();
        };

        var onFileSelected = (x: HTMLInputElement) => this.eventAggregator.publish(
            new ActivityExecutionRequested(this.activityName, this.fieldContext, [new ActivityFileParameter('Content', x)], afterUpload)
        );

        if (confirmationRequired) {
            this.eventAggregator.publish(new DialogRequested(new ConfirmUploadDialog(this.resources, onFileSelected)));
        } else {
            var $input = $('<input type="file" name="file" id="file" />').appendTo(this.$element);
            $input.on('change',() => onFileSelected(<HTMLInputElement>$input[0]));
            this.inputDisposable.set(disposable(() => $input.remove()));
            $input.trigger('click');
        }            
    }
}

registerBinding('uploadcontrol', UploadControl);
